import { render, staticRenderFns } from "./archives.vue?vue&type=template&id=7884131f&scoped=true"
import script from "./archives.vue?vue&type=script&lang=js"
export * from "./archives.vue?vue&type=script&lang=js"
import style0 from "./archives.vue?vue&type=style&index=0&id=7884131f&prod&scoped=true&lang=css"
import style1 from "./archives.vue?vue&type=style&index=1&id=7884131f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7884131f",
  null
  
)

export default component.exports